StatementsManager.HANDLERS.CourseCompleted = StatementHandler.extend({

	handleBlockInitialized: function(e) {
		StatementHandler.prototype.handleBlockInitialized.call(this, e);

		var block = e.blockData.view;
		if(block instanceof Survey) {
			this.listenTo(block, "onSurveyComplete", this.handleSurveyComplete);
		}
	},

	handleSurveyComplete: function(e) {
		this.addDataItem({});
		this.ready();
	}
});
